<ng-container *ngIf="item.is_toggle; else regularBtn">
  <!-- Interruptor: el switch va a la izquierda y la card toma el color del estado -->
  <button
    type="button"
    class="command-btn command-btn--toggle"
    [ngClass]="dotClass"
    [class.is-disabled]="item.disabled"
    [disabled]="item.disabled"
    (click)="onRun()"
  >
    <span class="command-toggle" [ngClass]="toggleClass">
      <span class="command-toggle__knob"></span>
    </span>
    <span class="command-btn__text">
      <span class="command-btn__label">{{ item.label_key | translate }}</span>
      <small class="command-btn__count">
        <ng-container *ngIf="item.status !== 'idle'; else idleCount">
          {{ item.answered }}/{{ item.total }} {{ "testing.answered-count" | translate }}
        </ng-container>
        <ng-template #idleCount>{{ "testing.command-idle" | translate }}</ng-template>
      </small>
    </span>
  </button>
</ng-container>

<ng-template #regularBtn>
  <button
    type="button"
    class="command-btn"
    [ngClass]="dotClass"
    [class.is-disabled]="item.disabled"
    [disabled]="item.disabled"
    (click)="onRun()"
  >
    <span class="command-btn__icon">
      <app-image-color
        [url]="iconUrl"
        [color]="iconColor"
        [height]="iconHeight"
        [width]="iconWidth"
      ></app-image-color>
    </span>
    <span class="command-btn__text">
      <span class="command-btn__label">{{ item.label_key | translate }}</span>
      <small class="command-btn__count">
        <ng-container *ngIf="item.total > 0; else noTargets">
          {{ item.answered }}/{{ item.total }} {{ "testing.answered-count" | translate }}
        </ng-container>
        <ng-template #noTargets>{{ "panel-alerts.no-targets" | translate }}</ng-template>
      </small>
    </span>
    <!-- Estado del comando con el mismo badge circular que los contadores del pie -->
    <span
      *ngIf="statusIcon"
      class="command-btn__badge"
      [ngClass]="dotClass"
      placement="right"
      container="body"
      [ngbTooltip]="statusLabel | translate"
    >
      <em class="fa" [ngClass]="statusIcon" aria-hidden="true"></em>
    </span>
  </button>
</ng-template>
